import { EntityType } from '../api/octopus/models/entity-type';
import { ModuleType } from '../enums/module-type';

export const ENTITY_BY_MODULE: Partial<Record<ModuleType, EntityType>> = {
  [ModuleType.AddressBook]: EntityType.AbEntry,
  [ModuleType.Lead]: EntityType.Lead,
  [ModuleType.Opportunity]: EntityType.Opportunity,
  [ModuleType.OpportunityViewer]: EntityType.Opportunity,
  [ModuleType.Case]: EntityType.Case,
  [ModuleType.CaseViewer]: EntityType.Case,
};
